import { GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { FilingLink } from "../../../../stateOffice/pages/FilingBuilder/components";
import { statusAPI } from "../../../../utils/api";

interface Column {
  field: string; // create a column bound to the "name" field
  title: string; // set its title to "Name
  hidden: boolean; // used to define if a column should be rendered or not
  download: boolean;
}

export const setOpenForCommentData = async (rows: any) => {
  const newRows: any = [];
  let columns: any = [];

  let column: Column;
  let agencyColumn: Column = {
    field: "agency",
    title: "Agency",
    hidden: false,
    download: false,
  };
  let ruleColumn: Column = {
    field: "rule",
    title: "Title Number",
    hidden: false,
    download: false,
  };
  let chapterColumn: Column = {
    field: "chapter",
    title: "Chapter Number",
    hidden: false,
    download: false,
  };
  let filingTypeColumn: Column = {
    field: "filingType",
    title: "Filing Type",
    hidden: false,
    download: false,
  };
  let commentOpenDateColumn: Column = {
    field: "commentOpenDate",
    title: "Comment Open Date",
    hidden: false,
    download: false,
  };
  let commentCloseDateColumn: Column = {
    field: "commentCloseDate",
    title: "Comment Closing Date",
    hidden: false,
    download: false,
  };
  let docketNumberColumn: Column = {
    field: "docketNumber",
    title: "Docket Number",
    hidden: false,
    download: false,
  };
  let proposedRuleDocumentPdfColumn: Column = {
    field: "pdf",
    title: "Proposed Rule Document",
    hidden: false,
    download: true,
  };
  let commentColumn: Column = {
    field: "comment",
    title: "Comment",
    hidden: false,
    download: false,
  };
  columns.push(
    ruleColumn,
    chapterColumn,
    agencyColumn,
    filingTypeColumn,
    commentOpenDateColumn,
    commentCloseDateColumn,
    docketNumberColumn,
    proposedRuleDocumentPdfColumn,
    commentColumn
  );

  // workflow id 13 == fee increase
  // TODO: May need to get statuses that are published etc.. and get their id's
  // let statusList: any = await statusAPI.getStatusesByWorkflowId(8);
  // let publishedStatusId: any;
  // statusList.result.forEach((status: any, index: number) => {
  //   if (status.name == "Published") {
  //     publishedStatusId = status.id;
  //     return;
  //   }
  // });

  rows.forEach((item: any, index: number) => {
    let ruleId = null;
    let chapterNumber = null;
    let agencyName = null;
    let filingTypeName = null;
    let commentOpenDate = null;
    let commentCloseDate = null;
    let docketNumber = null;
    let draftId = null;
    let email = null;

    if (item.entity.rule) {
      ruleId = +item.entity.rule.referenceCode;
      agencyName = item.entity.rule.title;
    }

    if (item.entity.chapter) {
      chapterNumber = +item.entity.chapter.chapterNum;
    }

    if (item.entity.commentBeginDate) {
      let date = new Date(item.entity.commentBeginDate);
      commentOpenDate = date.toLocaleDateString();
    }

    if (item.filingType) {
      if (item.filingType.name == "Notice-NRI") {
        filingTypeName = "Proposed Rules (NRI)";
      } else {
        filingTypeName = item.filingType.name;
      }
    }

    if (item.entity.commentEndDate) {
      let date = new Date(item.entity.commentEndDate);
      commentCloseDate = date.toLocaleDateString();
    }

    if (item.entity.draft.id) {
      draftId = item.entity.draft.id;
    }

    if (item.entity?.liaison?.email) {
      email = item.entity.liaison.email;
    }

    if (item.docket) {
      docketNumber = item.docket.year + "-" + item.docket.documentNumber;
    }

    let rowData = {
      id: item.id,
      rule: ruleId,
      chapter: chapterNumber,
      agency: agencyName,
      filingType: filingTypeName,
      commentOpenDate: commentOpenDate,
      commentCloseDate: commentCloseDate,
      docketNumber: docketNumber,
      draftId: draftId,
      expanded: false,
      email: email,
    };
    newRows.push(rowData);
    // }
  });

  return { rows: newRows, columns: columns };
};
